<template>
  <div :class="['banner-container', classBase + 'banner', isAutoWidth ? 'auto-banner' : '']">
    <swiper
      ref="mySwiper"
      :auto-destroy="true"
      :auto-update="true"
      :options="isAutoWidth ? authWidthOption : wapOptions"
      class="swiper-box"
    >
      <template v-for="item in list">
        <swiper-slide :key="item.id" class="banner-item" v-if="!item.is_app">
          <a
            :href="item.jump_url || 'javascript:;'"
            :target="item.jump_url ? '_blank' : '_self'"
            :title="gameInfo.name"
          >
            <img :src="item.thumb" :alt="gameInfo.name" class="swiper-lazy" />
          </a>
        </swiper-slide>
      </template>
    </swiper>
    <div class="swiper-button-next"></div>
    <div class="swiper-button-prev"></div>
    <div class="swiper-pagination"></div>
  </div>
</template>

<script>
import { directive, Swiper, SwiperSlide } from "vue-awesome-swiper";
import { mapGetters } from "vuex";
export default {
  name: "bannerContainer",
  mixins: [],
  props: {
    isAutoWidth: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  model: {},
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  data() {
    return {
      wapOptions: {
        loop: true,
        slidesPerView: 1,
        centeredSlides: true,
        autoplay: true,
        cssMode: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        clickable: true,
        pagination: {
          el: ".swiper-pagination"
        }
      },
      authWidthOption: {
        freeMode: true,
        slidesPerView: "auto",
        spaceBetween: 20,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  },
  computed: {
    ...mapGetters(["gameInfo"]),
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  methods: {
    handleJumpUrl(item) {
      console.log(item);
      if (item.jump_url) {
        window.open(item.jump_url);
      }
    }
  },
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
};
</script>

<style lang="less" scoped>
.banner-container {
  width: 100%;
  border-radius: 6px;

  .swiper-box {
    width: 100%;
    height: 100%;
  }

  .banner-item {
    // height: 100%;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 6px;
      background: #fff;
    }
  }

  &.wap-banner {
    .banner-item {
      width: 282px;

      &.swiper-slide-active {
        img {
          transform: scale(1, 1);
        }
      }

      img {
        transform: scale(0.95, 0.9);
      }
    }
  }
}

.auto-banner {
  /deep/ .swiper-slide {
    width: auto;
    img {
      display: block;
      width: auto;
      object-fit: cover;
    }
  }
}

.pc-banner {
  width: 100%;
  height: 235px;
  // padding-bottom: 20px;
  margin-bottom: 24px;
  position: relative;

  /deep/ .swiper-slide {
    // padding: 0 98px;

    img {
      // border: 2px solid #fff;
      height: 235px;
    }
  }
}
.swiper-button-prev {
  width: 32px;
  height: 80px;
  color: #fff;
  margin-top: -35px;
  background: rgba(0, 0, 0, 0.35);
  &::after {
    font-size: 20px;
  }
}
.swiper-button-next {
  width: 32px;
  height: 80px;
  color: #fff;
  margin-top: -35px;
  background: rgba(0, 0, 0, 0.35);
  &::after {
    font-size: 20px;
  }
}

.swiper-pagination {
  bottom: 8px;
  width: 100%;
  text-align: center;

  /deep/ .swiper-pagination-bullet {
    width: 10px;
    height: 6px;
    background: #f8f8f8;
    border-radius: 3px;
    opacity: 1;
    margin: 0 4px;
  }

  /deep/ .swiper-pagination-bullet-active {
    width: 22px;
    background: #29c0f7;
  }
}
</style>
